<template>
  <div class="right-panel">
    <div class="right-btns">
      <div class="history">
        <el-select v-model="historyValue" placeholder="请选择" @change="handleSelectChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="searchBtn" v-if="rightCheckBType == 2" @click="toggleSearchInput">
        <i class="el-icon-search" style="font-size: 20px"></i>
      </div>
      <div class="refreshBtn" @click="refreshFun">
        <i class="el-icon-refresh-left" style="font-size: 20px"></i>
      </div>
    </div>

    <!-- 历史聊天用户数据 -->
    <div class="message_list" id="historyMessageList" v-show="rightCheckBType == 1" @scroll="handleScroll"
      ref="historyMessageList">
      <template v-if="historyList.length > 0">
        <messageCard ref="messageCard" v-for="(item, index) in historyList"
          :key="`history-${item.idInterlocutor}-${item.id || Date.now()}-${index}`" :item="item"
          @click="clickHistory(item)" />
        <!-- 加载更多提示 -->
        <div v-if="isLoadingMore" class="loading-more">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        <!-- 观察目标元素 -->
        <div v-if="hasMore" ref="observerTarget" class="observer-target"></div>
        <!-- 没有更多数据提示 -->
        <div v-if="!hasMore && historyList.length > 0" class="no-more">
          <span>没有更多数据了</span>
        </div>
      </template>
      <!-- 历史消息空状态 -->
      <div v-else class="empty-state">
        <div class="empty-content">
          <div class="empty-icon">
            <img src="@/assets/history.png" alt="" />
          </div>
          <div class="empty-title">暂无历史对话</div>
          <div class="empty-subtitle">历史对话记录会在这里显示</div>
        </div>
      </div>
    </div>

    <!-- 搜索输入框 -->
    <div class="search-input-container" v-show="rightCheckBType == 2 && showSearchInput">
      <el-input v-model="searchKeyword" placeholder="请输入用户ID或昵称进行搜索" @input="handleSearchInput"
        @clear="handleSearchClear" clearable prefix-icon="el-icon-search" class="search-input">
      </el-input>
    </div>

    <div class="message_list" v-show="rightCheckBType == 2">
      <allMyUsers :isShow="createQMsgTypeShow" :searchKeyword="searchKeyword" ref="allMyUsersDom"
        @clickHistory="clickHistory"></allMyUsers>
    </div>
  </div>
</template>

<script>
import messageCard from './messageCard.vue'
import allMyUsers from './allMyUsers.vue'

export default {
  name: 'RightPanel',
  components: {
    messageCard,
    allMyUsers
  },
  props: {
    // 历史消息列表
    historyList: {
      type: Array,
      default: () => []
    },
    // 是否显示加载图片
    loadingImgShow: {
      type: Boolean,
      default: false
    },
    // 是否显示创建快捷消息类型
    createQMsgTypeShow: {
      type: Boolean,
      default: false
    },
    // 是否还有更多数据
    hasMore: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rightCheckBType: 1, // 用户选择的options的值
      options: [
        {
          value: '1',
          label: '历史对话'
        },
        {
          value: '2',
          label: '我的用户'
        }
      ],
      historyValue: '1',
      isLoadingMore: false, // 是否正在加载更多
      observer: null, // 观察者实例
      showSearchInput: false, // 是否显示搜索输入框
      searchKeyword: '' // 搜索关键词
    }
  },
  mounted() {
    this.initObserver()
  },
  beforeDestroy() {
    this.destroyObserver()
  },
  methods: {
    // 处理选择变化
    handleSelectChange(value) {
      this.rightCheckBType = value
      // 当切换到其他选项时，隐藏搜索输入框
      if (value !== '2') {
        this.showSearchInput = false
        this.searchKeyword = ''
      }
      this.$emit('selectChange', value)
    },

    // 刷新功能
    refreshFun() {
      this.$emit('refresh')
    },

    // 点击历史记录
    clickHistory(item) {
      this.$emit('clickHistory', item)
    },

    // 处理滚动事件
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      // 当滚动到距离底部100px时触发加载更多
      if (scrollHeight - scrollTop - clientHeight < 100 && !this.isLoadingMore && this.hasMore) {
        this.loadMore()
      }
    },

    // 加载更多数据
    loadMore() {
      if (this.isLoadingMore || !this.hasMore) return

      this.isLoadingMore = true
      this.$emit('loadMore')
    },

    // 初始化观察者
    initObserver() {
      if (!window.IntersectionObserver) {
        // 降级处理：使用滚动监听
        return
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.isLoadingMore && this.hasMore) {
              this.loadMore()
            }
          })
        },
        {
          root: this.$refs.historyMessageList,
          rootMargin: '100px',
          threshold: 0.1
        }
      )

      this.$nextTick(() => {
        if (this.$refs.observerTarget) {
          this.observer.observe(this.$refs.observerTarget)
        }
      })
    },

    // 销毁观察者
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    },

    // 重置加载状态
    resetLoadingState() {
      this.isLoadingMore = false
    },

    // 切换搜索输入框显示状态
    toggleSearchInput() {
      this.showSearchInput = !this.showSearchInput
      if (!this.showSearchInput) {
        this.searchKeyword = ''
        this.handleSearchClear()
      }
    },

    // 处理搜索输入
    handleSearchInput(value) {
      this.searchKeyword = value
      // 通知子组件进行搜索
      if (this.$refs.allMyUsersDom) {
        this.$refs.allMyUsersDom.handleSearch(value)
      }
    },

    // 处理搜索清除
    handleSearchClear() {
      this.searchKeyword = ''
      // 通知子组件清除搜索
      if (this.$refs.allMyUsersDom) {
        this.$refs.allMyUsersDom.handleSearch('')
      }
    }
  },
  watch: {
    // 监听历史列表变化，重新设置观察者
    historyList: {
      handler() {
        this.$nextTick(() => {
          if (this.observer && this.$refs.observerTarget) {
            this.observer.observe(this.$refs.observerTarget)
          }
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.right-panel {
  height: 100%;
  display: flex;
  flex-direction: column;

  .right-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid #e4e7ed;

    .history {
      flex: 1;
      margin-right: 10px;
    }

    .searchBtn {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 0.3s;
      margin-right: 8px;

      &:hover {
        background-color: #f5f7fa;
      }
    }

    .refreshBtn {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 0.3s;

      &:hover {
        background-color: #f5f7fa;
      }
    }
  }

  .search-input-container {
    padding: 10px 15px;
    border-bottom: 1px solid #e4e7ed;
    background-color: #fff;

    .search-input {
      width: 100%;
    }
  }

  .message_list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;

    .loadingImg {
      width: 20px;
      height: 20px;
      margin: 10px auto;
      display: block;
    }

    .rotate360 {
      animation: rotate360 1s linear infinite;
    }

    @keyframes rotate360 {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }

    .loading-more {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 0;
      color: #909399;
      font-size: 14px;

      i {
        margin-right: 8px;
        font-size: 16px;
        animation: rotate360 1s linear infinite;
      }
    }

    .no-more {
      text-align: center;
      padding: 20px 0;
      color: #c0c4cc;
      font-size: 14px;
    }

    .observer-target {
      height: 1px;
      width: 100%;
    }
  }

  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .empty-content {
      text-align: center;

      .empty-icon {
        margin-bottom: 16px;

        img {
          width: 64px;
          height: 64px;
          opacity: 0.6;
        }
      }

      .empty-title {
        font-size: 16px;
        color: #606266;
        margin-bottom: 8px;
      }

      .empty-subtitle {
        font-size: 14px;
        color: #909399;
      }
    }
  }
}
</style>
